/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserTypeEnum {
    USER = 'User',
    SERVICE = 'Service',
    ADMIN = 'Admin',
    SYS_ADMIN = 'SysAdmin',
}